import { loadCSS } from '../utils';
let view = null;

export default {
	namespace: 'home',
	beforeEnter: async ({ current, next, trigger }) => {
		await loadCSS(WPURLS.themeUrl + '/dist/css/_home.css');

		const { default: Home } = await import(/* webpackChunkName: "home" */ '../home/Home');
		view = new Home(next.container);

		// Logo animations
		if (current.container != null) {
			let header = document.querySelector('.c-header--frontpage');
			header.classList.add('c-header--frontpage--before-animation');

			let logos = header.querySelector('.c-header__logos');
			logos.classList.add('c-header__logos--visible');
			let menu = header.querySelector('.c-header-menu');
			menu.classList.add('c-header-menu--visible');

			next.container.classList.add('home--visible');
		}

		view.init();
	},
	afterEnter: ({ current, next, trigger }) => {
		//
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
